"use strict";
/// TODO: IMPLEMENT COMMENTS
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SingleComment_1 = __importDefault(require("./SingleComment"));
const NewPostInput_1 = require("./NewPostInput");
/**
 * Component that holds all the comments for a story
 */
const CommentsBlock = (props) => {
    return (react_1.default.createElement("div", { className: "Card-commentSection" },
        react_1.default.createElement("div", { className: "food-comments" },
            props.comments.map((comment) => (react_1.default.createElement(SingleComment_1.default, { key: `SingleComment_${comment._id}`, _id: comment._id, creator: comment.creator, creator_userId: comment.creator_userId, content: comment.content }))),
            react_1.default.createElement(NewPostInput_1.NewComment, { foodeventId: props.foodeventId, addNewComment: props.addNewComment }))));
};
exports.default = CommentsBlock;
